import * as React from 'react';
import * as styles from './styles.css';

import { Tab } from './Tab';
import { TabList } from './TabList';
import { TabContent } from './TabContent';

export interface ITabList {
  disabled?: boolean;
  label: React.ReactNode;
  content: React.ReactNode;
}

export interface ITabsProps {
  tabList: ITabList[];
  onChangeTab(activeIndex: number): void;
}

export function Tabs({ tabList, onChangeTab }: ITabsProps) {
  const [active, setActive] = React.useState(0);

  return (
    <div className={styles['tabs']}>
      <TabList>
        {tabList.map((tab, index) => {
          const { label, disabled } = tab;

          return (
            <Tab
              key={index}
              isNextTabActive={active === index + 1}
              isActive={active === index}
              disabled={disabled}
              onClick={
                disabled
                  ? undefined
                  : () => {
                      onChangeTab(index);
                      setActive(index);
                    }
              }
            >
              {label}
            </Tab>
          );
        })}
      </TabList>

      <TabContent>{tabList[active].content}</TabContent>
    </div>
  );
}
